export const crmCodes = {
  otherSalutation: 102900010,
  galleryAccount: '102900001'
}

export default {}
